import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { withRouter } from 'react-router-dom'

import { FlowRoute } from 'utils/FlowProvider/types'
import { getFeature } from 'utils/Optimizely/index'

const featureFlagRoutesMap = new Map<string, string>([['/event', 'event']])

const FeatureFlagRedirect = props => {
  const history = useHistory()
  const route = history?.location?.pathname

  useEffect(() => {
    if (featureFlagRoutesMap.has(route)) {
      for (const [k, v] of featureFlagRoutesMap) {
        if (!getFeature(v)) {
          history.push(FlowRoute.Welcome)
        }
      }
    }
  })

  return props.children
}

export default withRouter(FeatureFlagRedirect)
